import React, { HTMLAttributes, ReactElement } from 'react';
import classNames from 'classnames';
import { useSelector } from '@ecommerce/nest-ssr/common';

import type { ProductReviewInterface } from 'interfaces/product-review.interface';
import Carousel from 'atomic/carousel/carousel';
import ReviewSlide from 'atomic/review-slide/review-slide';

import './main-reviews.scss';

const MainProductReviews: React.FC<HTMLAttributes<HTMLElement>> = (
    {
        className
    }
): ReactElement => {
    const mainReviewsClasses = classNames(className, 'main-reviews');
    const recentProductReviews: ProductReviewInterface[] = useSelector(
        (state: { recentProductReviews: ProductReviewInterface[]; }) => state.recentProductReviews
    );

    return (
        <Carousel className={mainReviewsClasses}>
            {
                recentProductReviews
                    .map(({ id, author, product, content, rating, createdAt }) => (
                        <ReviewSlide
                            key={id}
                            author={author}
                            product={`${product.brand} ${product.model}`}
                            url={`/opinie-${product.id}-${product.slug}.html`}
                            description={content}
                            score={rating}
                            date={createdAt}
                        />
                    ))
            }
        </Carousel>
    );
};

export default MainProductReviews;
